import * as r from 'runtypes';

export const DeletionRequestRuntype = r.Record({
    code: r.String,
    last_changed_at: r.String,
    status: r.Number,
});

export type DeletionRequest = r.Static<typeof DeletionRequestRuntype>;
